import React from 'react';
import axios from "axios";
import { withRouter } from 'react-router-dom'
import { Row, Col, Skeleton } from 'antd';
import { withTranslation } from 'react-i18next';
import ClientCard from './ClientCard';

class ClientZoneView extends React.Component {
    state = {
        data: {},
        loading: true
    };


    componentWillMount() {
        let token = localStorage.getItem('token');
        axios.defaults.xsrfCookieName = 'csrftoken'
        axios.defaults.xsrfHeaderName = "X_CSRFTOKEN"
        axios.defaults.headers = {
            "Content-Type": "application/json",
            "Accept-Language": localStorage.getItem('language'),
            Authorization: `Token ${token}`,
        };

        this.fetch();
    }

    fetch = e => {
        let requestList = [];
        requestList.push(axios.get(process.env.REACT_APP_AXIOS_URL + "/api/service/user/"));

        axios.all(requestList).then(axios.spread((...responses) => {
            const responseService = responses[0];
            this.setState({
                data: responseService.data,
                loading: false
            });
        })).catch(errors => {
            console.log(errors);
        });
    }


    render() {
        const { t } = this.props;


        if (this.state.loading) {
            return (
                <div>
                    <Skeleton active />
                    <Skeleton active />
                    <Skeleton active />
                    <Skeleton active />
                </div>
            );
        } else {
            return (
                <div>
                    <Row gutter={8}>
                        <Col xl={8} md={12} sm={24}>
                            <ClientCard data={this.state.data} fetch={this.fetch} title={t('clients.client_zone.seo', "SEO")} service_name="seo" cardDescription={t('clients.client_zone.seo_description', "Search Engine Optimization")} />
                        </Col>
                        <Col xl={8} md={12} sm={24}>
                            <ClientCard data={this.state.data} fetch={this.fetch} title={t('clients.client_zone.maintenance', "Maintenance")} service_name='maintenance' cardDescription={t('clients.client_zone.maintenance_description', "Websites maintenance")} />
                        </Col>
                        <Col xl={8} md={12} sm={24}>
                            <ClientCard data={this.state.data} fetch={this.fetch} title={t('clients.client_zone.community_management', "Community management")} service_name='community_management' cardDescription={t('clients.client_zone.community_management_description', "Facebook and websites posting, content creation")} />
                        </Col>
                    </Row>
                    <Row gutter={8} style={{ marginTop: 16 }}>
                        <Col xl={8} md={12} sm={24}>
                            <ClientCard data={this.state.data} fetch={this.fetch} title={t('clients.client_zone.photography', "Photography")} service_name='photography' cardDescription={t('clients.client_zone.photography_description', "Photography of your business")} />
                        </Col>
                        <Col xl={8} md={12} sm={24}>
                            <ClientCard data={this.state.data} fetch={this.fetch} title={t('clients.client_zone.website_developement', "Website developement")} service_name='website_developement' cardDescription={t('clients.client_zone.website_developement_description', "Website upgrade or brand new")} />
                        </Col>
                        <Col xl={8} md={12} sm={24}>
                            <ClientCard data={this.state.data} fetch={this.fetch} title={t('clients.client_zone.unique_project', "Unique project")} service_name='unique_project' cardDescription={t('clients.client_zone.unique_project_description', "Different service than others")} />
                        </Col>
                    </Row>
                </div>
            );
        };

    }
}

export default withRouter(withTranslation()(ClientZoneView));


// WEBPACK FOOTER //
// ./src/containers/ClientZone/ClientZoneView.js